import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB8gjToIyljNCrkCTsQj0jSYGrvm327IJY",
  authDomain: "egram-chat.firebaseapp.com",
  projectId: "egram-chat",
  storageBucket: "egram-chat.appspot.com",
  messagingSenderId: "332299417659",
  appId: "1:332299417659:web:d9de016599644acc6b441e"
});

export const db = firebaseApp.firestore();
export const fb = firebase;
export const storage = firebaseApp.storage();
export const auth = firebaseApp.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();